<template>
  <div>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-edit"
          @click.native="handleInput"
          >添加</el-button
        >
      </el-form-item>

      <el-form-item class="query-form-item" label="链接类型">
        <el-select
          v-model="query.slidepictype"
          placeholder="不限"
          @change="onSubmit"
          clearable
        >
          <el-option label="商品" value="0"></el-option>
          <el-option label="链接地址" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="query-form-item">
        <el-input
          placeholder="标题"
          v-model="query.slidepictitle"
          prefix-icon="el-icon-search"
          @keyup.enter.native="onSubmit"
          clearable
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="onRest"
        ></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="list"
      :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column
        label="选择"
        prop="orderid"
        type="selection"
        :show-overflow-tooltip="true"
        width="50"
        align="center"
      />
      <el-table-column
        label="轮播图"
        prop="slidepicsite"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover">
            <img
              :src="scope.row.slidepicsite"
              style="width:400px;border-radius:3px;"
            />
            <img
              slot="reference"
              :src="scope.row.slidepicsite"
              style="max-height: 50px;max-width: 50px;border-radius:5px;"
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="标题" align="center" prop="slidepictitle" />
      <el-table-column label="链接类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.slidepictype == 0">商品</span>
          <span v-if="scope.row.slidepictype == 1">链接地址</span>
        </template>
      </el-table-column>
      <el-table-column
        label="链接地址/商品编码"
        align="center"
        prop="slidepicaddress"
      />
      <el-table-column label="序列号" align="center" prop="slidepicsort" />
      <el-table-column label="状态" align="center" prop="slidestatus">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            v-model="scope.row.status"
            @change="backgroundChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="300" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click.native="handleInfo(scope.$index, scope.row)"
            >查看</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click.native="handleForm(scope.$index, scope.row)"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click.native="handleDel(scope.row.slidepicid)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()"
        >删除已选</el-button
      >
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle"
          >取消选择</el-button
        >
      </transition>
    </div>
    <el-pagination
      class="pagination-container"
      background
      :page-size="query.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>

    <!--增加-->
    <el-dialog
      :visible.sync="formInput"
      :before-close="hideFormAdd"
      width="800px"
      top="5vh"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item label="标题:" prop="slidepictitle">
          <el-input v-model="formData.slidepictitle" type="text" />
        </el-form-item>
        <el-form-item label="序列号:" prop="slidepicsort">
          <el-input v-model="formData.slidepicsort" type="text" />
        </el-form-item>
        <el-form-item label="链接类型:" prop="slidepictype">
          <el-select
            v-model="formData.slidepictype"
            placeholder="不限"
            clearable
          >
            <el-option label="商品" value="0"></el-option>
            <el-option label="链接地址" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址/商品编码:" prop="slidepicaddress">
          <el-input v-model="formData.slidepicaddress" type="text" />
        </el-form-item>
        <el-form-item label="手机轮播图片:" prop="slidepicsite">
          <el-upload
            v-show="pic_is_show"
            class="avatar-uploader"
            style="margin-bottom: 15px;"
            accept=".png, .jpg, .gif, .jpeg, .bmp"
            :action="uploadUrl"
            :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              v-if="formData.slidepicsite"
              :src="formData.slidepicsite"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
            <div style="margin-top: -20px; margin-left: 100px;">
                <span style="color: #ff0000;font-size:10px;">建议：高810、宽1125</span>
            </div>
        </el-form-item>

          <el-form-item label="pc轮播图片:" prop="pcpic">
              <el-upload
                  v-show="pic_is_show"
                  class="avatar-uploader"
                  style="margin-bottom: 15px;"
                  accept=".png, .jpg, .gif, .jpeg, .bmp"
                  :action="uploadUrl"
                  :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
                  :show-file-list="false"
                  :on-success="handlePcSuccess"
              >
                  <img
                      v-if="formData.pcpic"
                      :src="formData.pcpic"
                      class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="margin-top: -20px; margin-left: 90px;">
                  <span style="color: red;font-size:10px;">建议：高360、宽1900</span>
              </div>
          </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideFormInput">取消</el-button>
        <el-button
          type="primary"
          @click.native="formSub()"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="800px"
      top="5vh"
      v-dialogDrag
      title="修改"
      :close-on-click-modal="false"
    >
      <el-form :model="formData" :rules="formRules" ref="dataForm">
        <el-form-item label="标题:" prop="slidepictitle">
          <el-input v-model="formData.slidepictitle" type="text" />
        </el-form-item>
        <el-form-item label="序列号:" prop="slidepicsort">
          <el-input v-model="formData.slidepicsort" type="text" />
        </el-form-item>
        <el-form-item label="链接类型:" prop="slidepictype">
          <el-select
            v-model="formData.slidepictype"
            placeholder="不限"
            clearable
          >
            <el-option label="商品" :value="0"></el-option>
            <el-option label="链接地址" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链接地址/商品编码:" prop="slidepicaddress">
          <el-input v-model="formData.slidepicaddress" type="text" />
        </el-form-item>

        <el-form-item label="手机轮播图片:" prop="slidepicsite">
          <el-upload
            v-show="pic_is_show"
            class="avatar-uploader"
            style="margin-bottom: 15px;"
            accept=".png, .jpg, .gif, .jpeg, .bmp"
            :action="uploadUrl"
            :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <img
              v-if="formData.slidepicsite"
              :src="formData.slidepicsite"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
            <div style="margin-top: -20px; margin-left: 100px;">
                <span style="color: red;font-size:10px;">建议：高810、宽1125</span>
            </div>
        </el-form-item>
          <el-form-item label="pc轮播图片:" prop="pcpic">
              <el-upload
                  v-show="pic_is_show"
                  class="avatar-uploader"
                  style="margin-bottom: 15px;"
                  accept=".png, .jpg, .gif, .jpeg, .bmp"
                  :action="uploadUrl"
                  :headers="{ hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg' }"
                  :show-file-list="false"
                  :on-success="handlePcSuccess"
              >
                  <img
                      v-if="formData.pcpic"
                      :src="formData.pcpic"
                      class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="margin-top: -20px; margin-left: 90px;">
                  <span style="color: red;font-size:10px;">建议：高360、宽1900</span>
              </div>
          </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button
          type="primary"
          @click.native="formSubmit()"
          :loading="formLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--  查看 --->
    <el-dialog
      title="基本信息"
      :visible.sync="formInfo"
      :before-close="hideInfo"
      width="1200px"
      top="5vh"
      v-dialogDrag
      :close-on-click-modal="false"
    >
      <el-form :model="formData">
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="标题:"
            prop="slidepictitle"
            style="width:50%;display: inline-block;margin-left:0px;"
          >
          <div v-html="formData.slidepictitle"/>
          </el-form-item>
          <el-form-item
            label="链接类型:"
            style="width:30%;display: inline-block"
          >
            <template>
              <span v-if="formData.slidepictype == 0">商品</span>
              <span v-if="formData.slidepictype == 1">链接地址</span>
            </template>
          </el-form-item>
        </el-form-item>
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="链接地址/商品编码:"
            prop="slidepicaddress"
            style="width:50%;display: inline-block;margin-left:0px;"
          >
            <input v-model="formData.slidepicaddress" type="text" readonly />
          </el-form-item>
          <el-form-item label="状态:" style="width:30%;display: inline-block">
            <template>
              <span v-if="formData.slidestatus == 0">开启</span>
              <span v-if="formData.slidestatus == 1">关闭</span>
            </template>
          </el-form-item>
        </el-form-item>
        <el-form-item
          style="border-bottom:1px solid #ebeef5;"
          label-width="0px"
        >
          <el-form-item
            label="序列号:"
            prop="slidepicsort"
            style="width:30%;display: inline-block"
          >
            <input v-model="formData.slidepicsort" type="text" readonly />
          </el-form-item>
        </el-form-item>
        <el-form-item label="轮播图片:" prop="slidepicsite">
          <template>
            <img
              :src="formData.slidepicsite"
              style="width:400px;border-radius:3px;"
            />
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getList,
  deleteSlidePic,
  addSlidePic,
  updateSlidePic,
  changeStatus,
  getCount
} from "../../api/slidepic/slidepic.js";
import { BASE_URL } from "../../config/app";
const formJson = {
  slidepicid: "",
  slidepictitle: "",
  slidepicsort: "",
  slidepictype: "",
  slidepicaddress: "",
  slidepicsite: "",
  pcpic: "",
  slidestatus: "",
  status: ""
};

export default {
  data() {
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入标题"));
      } else {
        callback();
      }
    };
    var checkSort = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入序列号"));
      } else {
        var reg = /^[0-9]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正整数"));
        }
      }
    };
    var checkType = (rule, value, callback) => {

      if (value!=null && value.length==0) {
        return callback(new Error("请选择链接类型"));
      } else {
        callback();
      }
    };
    // var checkAddress = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error("请输入链接地址或者商品编码"));
    //   } else {
    //     callback();
    //   }
    // };

    var checkUrl = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请上传轮播图"));
      } else {
        callback();
      }
    };


        return {
            slidepicid:"",
            slidepictitle:"",
            slidepicsort:"",
            slidepictype:"",
            slidepicaddress:"",
            slidepicsite:"",
            pcpic: "",
            slidestatus:"",
            status:"",
            count:"",
            dialogVisible: false,
            cancelToggle:false,
            servicestarttime: [],
            query: {
                slidepicid:"",
                slidestatus:"",
                slidepictitle:"",
                slidepictype:"",
                currentPage: 1,
                pageSize: 10
            },
            list: [],
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            formLoading: false,
            formVisible: false,
            formInfo:false,
            formInput:false,
            formData: {
                slidepicid: "",
                slidepictitle: "",
                slidepicsort: "",
                slidepictype: "",
                slidepicaddress: "",
                slidepicsite: "",
                pcpic: "",
                slidestatus: "",
                status: ""
            },
            formRules: {
                slidepictitle: [{ validator: checkTitle, trigger: "blur" }],
                slidepicsort: [{ validator: checkSort, trigger: "blur" }],
                slidepictype: [{ validator: checkType, trigger: "blur" }],
                // slidepicaddress: [{ validator: checkAddress, trigger: "blur" }],
                slidepicsite: [{ validator: checkUrl, trigger: "blur" }],
                pcpic: [{ validator: checkUrl, trigger: "blur" }],

            },
            multipleSelection: [], //多选集合
            uploadUrl: BASE_URL + "/upload/tool/uploadpro",
            pic_is_show: true,
        };
    },
    methods:{
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    dateChange(val) {
      if (val == null) {
        this.query.startTime = "";
        this.query.endTime = "";
      } else {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      }
      this.getList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (val == "") {
        this.cancelToggle = false;
        return;
      }
      this.cancelToggle = true;
    },
    delGroup() {
      var ids = this.multipleSelection.map(item => item.slidepicid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
      if (ids == "") {
        this.$message({
          message: "请先选择",
          type: "warning"
        });
        return;
      }
      this.handleDel(ids);
    },
    onRest() {
      this.query = {
        currentPage: 1,
        pageSize: 10
      };
      this.msgtime = [];
      this.getList();
    },
    onSubmit() {
      this.$router.push({
        path: "",
        query: this.query
      });
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      //scrollTo(0, 800);
      this.getList();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getList();
    },
    handleAvatarSuccess(res, file) {
      this.formData.slidepicsite = res.data;

    }, handlePcSuccess(res, file) {
            this.formData.pcpic = res.data;
            console.info('res=',res);
            console.info('file=',file);
        },

    getList() {
      this.loading = true;
      console.log(this.query);
      getList(this.query)
        .then(response => {
          if (response.code) {
            this.$message.errsor(response.message);
          }

          this.list = response.data.list || [];
          this.totalNumber = response.data.totalNumber || 0;
          setTimeout(() => {
            this.loading = false;
          }, 0.3 * 1000);
        })
        .catch(() => {
          this.loading = false;
          this.list = [];
          this.totalNumber = 0;
        });
    },
    // 隐藏表单
    hideForm() {
      // 更改值
      this.formVisible = !this.formVisible;
      return true;
    },
    hideFormAdd() {
      // 更改值
      this.formInput = !this.formInput;
      return true;
    },

    hideFormInput() {
      // 更改值
      this.formInput = !this.formInput;
      return true;
    },

    hideInfo() {
      // 更改值
      this.formInfo = !this.formInfo;
      // 清空表单
      this.$refs["dataForm"].resetFields();
      this.query.slidepictitle = "";
      return true;
    },
    hideInput() {
      // 更改值
      this.formInput = !this.formInput;
      // 清空表单
      this.$refs["dataForm"].resetFields();
      this.query.slidepictitle = "";
      return true;
    },
    // 显示表单
    handleForm(index, row) {
      this.formVisible = true;
      this.formData = row;
      this.index = index;
      // 清空验证信息表单
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].clearValidate();
      }
    },

    handleInput() {
      this.formInput = true;
       this.resetFame()
      // 清空验证信息表单

      // if (this.$refs["dataForm"]) {
      //
      //   this.$refs["dataForm"].clearValidate();
      // }
    },
        resetFame(){
            this.formData.slidepicid=""
            this.formData.slidepictitle=""
            this.formData.slidepicsort=""
            this.formData.slidepictype=""
            this.formData.slidepicaddress= ""
            this.formData.slidepicsite= ""
            this.formData.pcpic= ""
            this.formData.slidestatus= ""
            this.formData.status= ""
        },

    handleInfo(index, row) {
      this.formInfo = true;
      this.formData = row;
      // 清空验证信息表单
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].clearValidate();
      }
    },

    formSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.formData.msgtime = "";
          let data = Object.assign({}, this.formData);
          updateSlidePic(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            this.$refs["dataForm"].resetFields();
            this.formVisible = false;
            this.query.slidepictitle = "";
            this.getList();
          });
        }
      });
    },

    formSub() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.formLoading = true;
          let data = Object.assign({}, this.formData);
          console.log(data);
          addSlidePic(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            //this.$refs["dataForm"].resetFields();
            this.formInput = false;
            this.query.slidepictitle = "";
            this.getList();
          });
        }
      });
    },
    //状态改变
    backgroundChange(row) {
      getCount().then(response => {
        this.formLoading = false;
        if (response.code) {
          this.$message.error(response.message);
          return false;
        }
        this.count = response.data || 0;
        if (!row.status) {
          this.query.slidepicid = row.slidepicid;
          if (row.slidestatus == 0) {
            this.query.slidestatus = 1;
          } else {
            this.query.slidestatus = 0;
          }
          let data = Object.assign({}, this.query);
          console.log(data);
          changeStatus(data).then(response => {
            this.formLoading = false;
            if (response.code) {
              this.$message.error(response.message);
              return false;
            }
            this.$message.success("操作成功");
            // 刷新表单
            //this.$refs["dataForm"].resetFields();
            this.query.slidepicid = "";
            this.query.slidestatus = "";
            this.getList();
          });
        } else {
          if (this.count < 6) {
            this.query.slidepicid = row.slidepicid;
            if (row.slidestatus == 0) {
              this.query.slidestatus = 1;
            } else {
              this.query.slidestatus = 0;
            }
            let data = Object.assign({}, this.query);
            console.log(data);
            changeStatus(data).then(response => {
              this.formLoading = false;
              if (response.code) {
                this.$message.error(response.message);
                return false;
              }
              this.$message.success("操作成功");
              // 刷新表单
              //this.$refs["dataForm"].resetFields();
              this.query.slidepicid = "";
              this.query.slidestatus = "";
              this.getList();
            });
          } else {
            row.status = false;
            this.$message.error("轮播图最多可同时打开6个");
          }
        }
      });
    },
    // 删除
    handleDel(ids) {
      if (ids) {
        this.$confirm("确认要删除吗?", "提示", {
          type: "warning"
        })
          .then(() => {
            this.loading = true;
            var params = new URLSearchParams();
            params.append("ids", ids);
            deleteSlidePic(params)
              .then(response => {
                this.loading = false;
                if (response.code) {
                  this.$message.error(response.message);
                  return false;
                }
                this.$message.success("删除成功");
                // 刷新数据
                //this.list.splice(index, 1);
                this.getList();
              })
              .catch(() => {
                this.loading = false;
              });
          })
          .catch(() => {});
      }
    },
    },
  created() {
    // 将参数拷贝进查询对象
    let query = this.$route.query;
    this.query = Object.assign(this.query, query);
    this.query.pageSize = parseInt(this.query.pageSize);
    // 加载表格数据
    this.getList();
  }
};
</script>

<style type="text/scss" lang="scss">
body {
  margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
